const filterMateriPemb = {
    idSekolah: 0,
    idGuru: 0,
    idSubBab: null,
    idPembTema: null,
    typeContent: '',
    owner: ''
}

export default filterMateriPemb;